import { render } from "./FormOrder.vue?vue&type=template&id=29b5af98"
import script from "./FormOrder.vue?vue&type=script&lang=js"
export * from "./FormOrder.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/app/components/FormOrder.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "29b5af98"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('29b5af98', __exports__)) {
    api.reload('29b5af98', __exports__)
  }
  
  module.hot.accept("./FormOrder.vue?vue&type=template&id=29b5af98", () => {
    api.rerender('29b5af98', render)
  })

}


export default __exports__